import {
  EDIT_SERVICE_CATEGORY,
  FETCH_SERVICE_CATEGORY,
  UPDATE_ACTIVE_TO_ORCAMENT_CATEGORY,
} from './ServiceCategoryActions'

const INITIAL_STATE = {
  items: [],
  filters: [],
  meta: {},
  editingServiceCategory: null,
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_SERVICE_CATEGORY.SUCCESS:
      return {
        ...state,
        items: action.payload.data,
        meta: action.payload.meta,
      }
    case EDIT_SERVICE_CATEGORY.SUCCESS:
      return {
        ...state,
        editingServiceCategory: action.payload,
      }
    case UPDATE_ACTIVE_TO_ORCAMENT_CATEGORY.SUCCESS:
      return {
        ...state,
        items: state.items.map(item =>
          item.id === action.payload.data.id
            ? { ...item, active_to_orcament: action.payload.data.active_to_orcament }
            : item
        ),
      }
    default:
      return state
  }
}

export const getServiceCatListData = state => {
  return {
    items: state.serviceCategory.items,
  }
}

export const getEditingServiceCat = state => {
  return state.serviceCategory.editingServiceCategory
}
